// src/pages/FAQ.js

import React, { useEffect, useState } from "react";
import "./CMSDetails.css";
import apiService from "../../../services/api";

export default function FAQ() {
  const [cms, setCms] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCMS = async () => {
    try {
      const res = await apiService.getCMSDetails("faq");
      console.log("FAQ CMS Response:", res);

      const cmsData = res?.data?.data || null;
      setCms(cmsData);
    } catch (err) {
      console.error("FAQ Fetch Error:", err);
      setCms(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCMS();
  }, []);

  return (
    <div className="cms-container">
      {loading ? (
        <p className="cms-loading">Loading...</p>
      ) : !cms ? (
        <p className="cms-empty">No CMS data found</p>
      ) : (
        <div className="cms-card" key={cms._id}>
          <h3 className="cms-item-title">{cms.name}</h3>
          <p className="cms-item-content">{cms.content}</p>

          {cms.image && cms.image.trim() !== "" && (
            <img className="cms-image" src={cms.image} alt="faq" loading="lazy" />
          )}
        </div>
      )}
    </div>
  );
}
